@use "../../styles/breakpoint.module.scss" as *;

.modal {
    position: fixed;
    inset: 0;
    z-index: 100;
}

.dialog {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    align-items: center;
    height: 100%;
    outline: 0;
}

.overlay {
    position: absolute;
    inset: 0;
    background-color: rgb(var(--black-base) / 45%);
    z-index: 0;
}

.trigger {
    align-self: center;
    margin-top: var(--spacer-16);
}

.content {
    max-height: 94vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background-color: var(--white);
    grid-column: 4 / span 6;
    z-index: 1;
    padding: var(--spacer-48);

    @media ($below-tablet) {
        grid-column: 3 / span 8;
    }

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}
